import { SeoHead } from "@/components/SeoHead";

type AppSeoProps = {
  /** Page title (without the " — Excerptus" suffix). */
  title: string;
  /** Optional description override. Defaults to a generic app blurb. */
  description?: string;
  /** When true (default), search engines are told not to index. */
  noindex?: boolean;
};

/**
 * Convenience wrapper around <SeoHead> for in-app/internal pages. Auto-suffixes
 * the title with " — Excerptus" and defaults to noindex so authenticated
 * surfaces don't accidentally get crawled.
 *
 * Use raw <SeoHead> directly on public marketing/legal routes where you want
 * full control over title and indexing.
 */
export const AppSeo = ({ title, description, noindex = true }: AppSeoProps) => (
  <SeoHead
    title={`${title} — Excerptus`}
    description={description ?? "Excerptus — the Knowledge Worker's second brain. Research, write, and publish from one source of truth."}
    noindex={noindex}
  />
);
